module.exports = __webpack_public_path__ + "static/media/icon_live.ff2b62fb.png";